import { Component, HostBinding, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';
import { SidenavItemComponent } from './sidenav-item/sidenav-item.component';
import { SidenavItem } from './sidenav-item/sidenav-item.interface';
import { SidenavService } from './sidenav.service';
import { ThemeService } from '../../../@fury/services/theme.service';
import {
  selectSystemInfo,
  selectSystemPreferences,
} from 'src/app/main/shared/services/store/misc/selectors';
import { ISystemInfo, ISystemPreferences } from 'src/app/core/dto';
import { ScrollbarComponent } from 'src/@fury/shared/scrollbar/scrollbar.component';
import { compareVersions } from 'src/app/main/shared/utils/version-utils';

@Component({
  selector: 'fury-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    SidenavItemComponent,
    ScrollbarComponent,
  ],
})
export class SidenavComponent implements OnInit, OnDestroy {
  sidenavUserVisible$ = this.themeService.config$.pipe(map((config) => config.sidenavUserVisible));
  dataSub_: Subscription;

  @Input()
  @HostBinding('class.collapsed')
  collapsed: boolean;

  @Input()
  @HostBinding('class.expanded')
  expanded: boolean;

  items$: Observable<SidenavItem[]>;
  systemInfoSub_: Subscription;
  systemInfo: ISystemInfo;
  versionComparison: number;
  systemPrefSub_: Subscription;
  systemPreferences: ISystemPreferences;

  constructor(
    private router: Router,
    private sidenavService: SidenavService,
    private themeService: ThemeService,
    private store: Store
  ) {
    this.systemInfoSub_ = this.store.select(selectSystemInfo).subscribe((systemInfo) => {
      this.systemInfo = { ...systemInfo };
      console.log('System Info:', this.systemInfo);
      if (this.systemInfo?.latestReleaseVersion?.version && this.systemInfo.version) {
        console.log(
          'Comparing versions:',
          this.systemInfo.latestReleaseVersion.version,
          this.systemInfo.version
        );
        this.versionComparison = compareVersions(
          this.systemInfo.latestReleaseVersion.version,
          this.systemInfo.version
        );
      }
    });

    this.systemPrefSub_ = this.store
      .select(selectSystemPreferences)
      .subscribe((systemPreferences) => {
        this.systemPreferences = { ...systemPreferences };
      });
  }

  ngOnInit() {
    this.items$ = this.sidenavService.items$.pipe(
      map((items: SidenavItem[]) => this.sidenavService.sortRecursive(items, 'position'))
    );
  }

  toggleCollapsed() {
    this.sidenavService.toggleCollapsed();
  }

  @HostListener('mouseenter')
  @HostListener('touchenter')
  onMouseEnter() {
    this.sidenavService.setExpanded(true);
  }

  @HostListener('mouseleave')
  @HostListener('touchleave')
  onMouseLeave() {
    this.sidenavService.setExpanded(false);
  }

  ngOnDestroy() {
    this.systemInfoSub_.unsubscribe();
    this.systemPrefSub_.unsubscribe();
  }
}
